module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av86-788b68ede04a1fbc9cb41eab335b3f07.jpg";